<template>
  <div class="home_index" ref="home_index">
    
    <div class="index_box">
      
      <div class="concernlist_box">
        <div class="concernlist_tit">{{day}}</div>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="getMyCalendarDay"
          :immediate-check="false"
        >
          <div class="concernlist" v-for="(item) in list" :key="item.id" @click="gotodetail(item.id)">
          <p>{{item.title}}</p>
          <span>提醒方式：{{item.remind}}</span>
          </div>
        </van-list>
      </div>
    </div>
    <tab-bar :current-index="0" />
  </div>
</template>
<script type="text/ecmascript-6">
import {
  List as VanList,
  Toast
} from 'vant';
import Vue from "vue";
import API from "../api";
import axios from "axios";
import TabBar from '../components/tabbar.vue';
export default {
  name: "",
  components: {
   TabBar,
   VanList,
  },
  data() {
    return {
      username: "",
      list:[],
      day:this.$route.params.day,
      page:1,
      size:15,
      loading: false,
      finished: false,
    };
  },
  computed: {
     
  },
  mounted() {
    this.getMyCalendarDay();
  },
  
  methods: {
    
    //获取日历单日关注列表
    async getMyCalendarDay(){
      const res = await API.getMyCalendarDay({day:this.day,page:this.page,size:this.size});
        this.loading = false;
        if(res.data.code === 444){
          //console.log(res.data.data)
          window.location.href = res.data.data
        }else if (res.data.code === 200) {
          this.list.push(...res.data.data.list)
          // console.log(this.list.length,res.data.data.count,this.loading,this.page)
          if (this.list.length < res.data.data.count) {
          //console.log(2)
            this.page += 1;
          }else{
            this.finished = true;
          }
        } else {
          this.finished = true;
          Toast(res.data.message);
        }
    },
   
    async gotodetail(id){
      //console.log(id)
      this.$router.push({ name: 'detail', params: { id: id } });
    }
  }
};
</script>



// WEBPACK FOOTER //
// calendarday.vue?1e4db846